(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["willow-auxiliary-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event){
  var select=event.target.closest('[data-wv-aux-variant]');
  if(!select) return;
  var root=select.closest('[data-wv-auxiliary]');
  var option=select.selectedOptions[0];
  if(!root || !option) return;
  root.querySelector('[data-wv-aux-price]').textContent=option.dataset.price;
  var button=root.querySelector('[data-wv-aux-submit]');
  button.disabled=option.dataset.available!=='true';
  button.querySelector('.btn-text > span').textContent=button.disabled?'Sold out':'Add sample to cart';
  var url=new URL(location.href);url.searchParams.set('variant',select.value);history.replaceState(null,'',url);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["willow-collection-mobile-controls"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  if (window.__wvCollectionMobileControls) return;
  window.__wvCollectionMobileControls = true;
  var mobile = window.matchMedia('(max-width: 767px)');
  var railScrollLeft = 0;
  var pendingDrawer = false;

  function restoreRail() {
    if (!mobile.matches) return;
    var rail = document.querySelector('[data-wv-mobile-navigation]');
    if (rail) rail.scrollLeft = railScrollLeft;
  }

  document.addEventListener('scroll', function (event) {
    if (mobile.matches && event.target.matches && event.target.matches('[data-wv-mobile-navigation]')) {
      railScrollLeft = event.target.scrollLeft;
    }
  }, { capture: true, passive: true });
  document.addEventListener('collection:reloaded', restoreRail);

  function openDrawer(trigger) {
    var drawer = document.getElementById('FacetDrawer');
    if (!drawer) return false;
    if (typeof drawer.show !== 'function' && window.customElements) {
      try { customElements.upgrade(drawer); } catch (_) {}
    }
    if (typeof drawer.show !== 'function') return false;
    if (!drawer.open) drawer.show(trigger);
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!mobile.matches || !event.target.closest) return;
    var trigger = event.target.closest('.wv-collection-mobile-toolbar__filter');
    if (trigger) {
      // Capture prevents the theme's generic drawer listener from double-toggling.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (openDrawer(trigger) || pendingDrawer || !window.customElements) return;
      var drawer = document.getElementById('FacetDrawer');
      if (!drawer) return;
      pendingDrawer = true;
      customElements.whenDefined(drawer.localName).then(function () {
        pendingDrawer = false;
        var liveTrigger = document.querySelector('.wv-collection-mobile-toolbar__filter');
        if (liveTrigger) openDrawer(liveTrigger);
      }).catch(function () { pendingDrawer = false; });
      return;
    }

    var link = event.target.closest('[data-wv-mobile-navigation] a[data-wv-filter-url]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = link.getAttribute('data-wv-filter-url');
    if (!target) return;
    var url;
    try { url = new URL(target, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    if (link.hasAttribute('data-wv-clear-filters')) {
      var sort = new URL(window.location.href).searchParams.get('sort_by');
      if (sort) url.searchParams.set('sort_by', sort);
      railScrollLeft = 0;
    } else {
      railScrollLeft = link.closest('[data-wv-mobile-navigation]').scrollLeft;
    }
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = document.querySelector('form[is="facet-form"]');
    // Shopify's URLs preserve filters from other dimensions. Desktop crawlable
    // collection hrefs remain unchanged; mobile stays within this collection.
    if (form && typeof form.renderSection === 'function' && window.theme && theme.utils && typeof theme.utils.sectionId === 'function') {
      url.searchParams.set('section_id', theme.utils.sectionId(form));
      form.renderSection(url.toString(), event);
    } else {
      // Works before customized built-ins upgrade, including WebKit's fallback path.
      window.location.assign(url.toString());
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["willow-collection-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__wvCollectionDragScroll) return;
  window.__wvCollectionDragScroll = true;
  let drag = null;
  let suppressedClick = null;

  function scrollSurface(target) {
    const nav = target.closest?.('.wv-collection-nav');
    if (!nav) return null;
    const list = target.closest('.wv-collection-nav__links');
    return [list, nav].find((element) => element
      && element.scrollWidth > element.clientWidth + 1
      && /auto|scroll/.test(getComputedStyle(element).overflowX)) || null;
  }

  function finishDrag(event) {
    if (!drag || (event?.pointerId !== undefined && event.pointerId !== drag.pointerId)) return;
    const previous = drag;
    drag = null;
    if (previous.moved) {
      suppressedClick = { surface: previous.surface, until: performance.now() + 500 };
    }
    previous.surface.classList.remove('wv-collection-is-dragging');
    if (previous.surface.hasPointerCapture(previous.pointerId)) {
      previous.surface.releasePointerCapture(previous.pointerId);
    }
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    scrollSurface(event.target)?.classList.add('wv-collection-drag-scroll');
  });

  document.addEventListener('pointerdown', (event) => {
    suppressedClick = null;
    if (event.pointerType !== 'mouse' || event.button !== 0
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    finishDrag();
    const surface = scrollSurface(event.target);
    if (!surface) return;
    surface.classList.add('wv-collection-drag-scroll');
    drag = { surface, pointerId: event.pointerId, x: event.clientX, y: event.clientY,
      left: surface.scrollLeft, moved: false };
  });

  window.addEventListener('pointermove', (event) => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    if (!drag.surface.isConnected || event.buttons === 0) { finishDrag(event); return; }
    const dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (!drag.moved) {
      if (Math.abs(dy) > 6 && Math.abs(dy) > Math.abs(dx)) { finishDrag(event); return; }
      if (Math.abs(dx) < 6) return;
      drag.moved = true;
      drag.surface.classList.add('wv-collection-is-dragging');
      drag.surface.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    drag.surface.scrollLeft = drag.left - dx;
  }, { capture: true, passive: false });

  window.addEventListener('pointerup', finishDrag, true);
  window.addEventListener('pointercancel', finishDrag, true);
  window.addEventListener('lostpointercapture', finishDrag, true);
  window.addEventListener('blur', () => finishDrag());

  document.addEventListener('dragstart', (event) => {
    if (drag?.surface.contains(event.target)) event.preventDefault();
  }, true);

  window.addEventListener('click', (event) => {
    if (!suppressedClick || event.detail === 0) return;
    const blocked = suppressedClick;
    suppressedClick = null;
    if (performance.now() < blocked.until && blocked.surface.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["willow-sidesplash-preview"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  const normalize = value => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  const ALIASES = {
    'empira white quartz':['Empira Quartz Arvin','Empira Quartz Bob','Empira White Quartz'],
    'empira quartz':['Empira Quartz Arvin','Empira Quartz Bob','Empira White Quartz'],
    'white quartz':['White Arvin','White','White Elsa'],
    'calacatta laza quartz':['Calacatta Laza','Calacatta Laza Quartz'],
    'calacatta nuvo quartz':['Calacatta Nuvo','Calacatta Nuvo Quartz'],
    'calacatta black quartz':['Calacatta Black'],
    'calacatta sienna quartz':['Calacatta Sienna','Calacatta Sienna Quartz'],
    'calacatta poanazzo quartz':['Calacatta Poanazzo Elsa'],
    'viola brown quartz':['Viola Brown'],
    'viola gold quartz':['Calacatta Viola Gold Quartz'],
    'viola night quartz':['Calacatta Viola Night Quartz'],
    'palissandro quartz':['Palissandro White']
  };
  // Name aliases are visual-review candidates ONLY, never an approved SKU binding.
  function candidates(rows, name, height) {
    const key=normalize(name).replace(/^dc /,'');
    const names=(ALIASES[key] || [key]).map(normalize);
    return rows.filter(row => row.height===height && names.includes(normalize(row.material)));
  }
  function pieces(choice, quantity) {
    const per=choice==='single'?1:choice==='double'?2:0;
    const qty=Number(quantity);
    return Number.isSafeInteger(qty)&&qty>0 ? per*qty : 0;
  }
  function capacity(rows, quantity) {
    const qty=Number(quantity);
    if(!Number.isSafeInteger(qty)||qty<1)return {single:false,double:false};
    // Never combine different suppliers' stock to invent one matching pack.
    const stock=Math.max(0,...rows.map(row=>Number.isSafeInteger(row.availableSnapshot)?row.availableSnapshot:0));
    return {single:stock>=qty,double:stock>=2*qty};
  }
  // A production match must resolve to exactly one physical SKU. Never choose
  // a different supplier merely because that supplier currently has stock.
  function purchaseMatch(rows, name, height) {
    const found=candidates(rows,name,height);
    return found.length===1 ? found[0] : null;
  }
  function selectionItem(row, choice, quantity, vanityId, title) {
    const qty=Number(quantity), double=choice==='double';
    if(!row||!['single','double'].includes(choice)||!Number.isSafeInteger(qty)||qty<1)return null;
    const id=double?row.doubleVariantId:row.singleVariantId;
    const stock=double?row.doubleAvailable:row.availableSnapshot;
    if(!/^\d+$/.test(String(id||''))||!Number.isSafeInteger(stock)||stock<qty)return null;
    return {id:String(id),quantity:qty,properties:{
      'Sidesplash':double?'Double — 2 pieces per set':'Single — 1 piece',
      'For vanity':title,'_wv_vanity_variant':String(vanityId),
      '_wv_sidesplash_sku':double?row.proposedDoubleSku:row.singleSku
    }};
  }
  function roundedProfile(title, top, group, sku='', handle='') {
    const signals=[title,top,group,sku,handle].join(' ');
    if(/(?:^|[^a-z0-9])r[\s_-]*100(?:$|[^a-z0-9])|\brounded\b/i.test(signals))return true;
    if(/^(?:HMP|HOU|MIA|ORL|BRL|VTR)(?:[_-]|$)/i.test(String(sku).trim()))return true;
    return /\b(?:hampton|houston|miami|orlando|brooklyn|ventura)\b/i.test(title+' '+handle);
  }
  function profile(title, top, group, sku='', handle='') {
    if(roundedProfile(title,top,group,sku,handle))return null;
    return /\bmanhattan\b/i.test(title+' '+handle)?5:4;
  }
  const rules={candidates,pieces,capacity,profile,roundedProfile,purchaseMatch,selectionItem};
  if(typeof module!=='undefined'&&module.exports){module.exports=rules;return;}
  if(customElements.get('willow-sidesplash-preview'))return;
  class SidesplashPreview extends HTMLElement {
    connectedCallback(){
      if(this.started)return;
      const source=this.querySelector('[data-side-data]');
      if(!source)return;
      try{this.data=JSON.parse(source.textContent);}catch(_){return;}
      // Only current published catalog data can enable a purchasable accessory.
      try {
        const live=JSON.parse(this.querySelector('[data-side-live-stock]').textContent);
        const byId=new Map(live.variants.map(v=>[String(v.id),v]));
        this.data.rows=this.data.rows.map(row=>{
          const v=byId.get(row.singleVariantId);
          const d=byId.get(row.doubleVariantId);
          const available=v&&v.available&&v.tracked&&v.policy==='deny'&&v.price===4500&&Number.isSafeInteger(v.quantity)?Math.max(0,v.quantity):0;
          const doubleAvailable=d&&d.available&&d.policy==='deny'&&d.price===9000&&Number.isSafeInteger(d.quantity)?Math.max(0,Math.min(d.quantity,Math.floor(available/2))):0;
          return Object.assign({},row,{availableSnapshot:available,doubleAvailable});
        });
      } catch(_) { this.data.rows=[]; }
      this.started=true; this.choice='none'; this.top=''; this.qty=1;
      this.copy=JSON.parse(this.querySelector('[data-side-copy]').textContent);
      this.availabilityNote=document.createElement('div');
      this.availabilityNote.className='wv-side-availability-note';
      this.availabilityNote.hidden=true;
      this.stockMessage=document.createElement('p');
      this.stockMessage.setAttribute('role','status');
      this.availabilityNote.appendChild(this.stockMessage);
      const guideRow=document.createElement('div');
      guideRow.className='wv-guide-help-row';
      const guide=document.createElement('a');
      guide.className='wv-guide-help';
      guide.href=this.data.guideUrl;
      guide.target='_blank';guide.rel='noopener noreferrer';
      guide.textContent=this.copy.guide_label;
      const arrow=document.createElement('span');
      arrow.className='wv-guide-help-arrow';arrow.setAttribute('aria-hidden','true');
      arrow.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M5 15 15 5M5 5h10v10"/></svg>';
      guide.appendChild(arrow);guideRow.appendChild(guide);this.availabilityNote.appendChild(guideRow);
      this.controller=new AbortController(); const signal=this.controller.signal;
      this.onConfig=()=>this.update();
      document.addEventListener('willow:configuration',this.onConfig,{signal});
      document.addEventListener('change',event=>{
        const input=event.target;
        const fs=input.closest?.('variant-picker .variant-input-wrapper');
        if(input.matches?.('input[type="radio"]')&&fs&&/countertop/i.test(fs.querySelector('legend')?.textContent||''))this.update();
      },{signal,capture:true});
      const quantityChanged=event=>{
        if(event.target.name==='quantity')this.update();
      };
      document.addEventListener('input',quantityChanged,{signal});
      document.addEventListener('change',quantityChanged,{signal});
      this.addEventListener('change',event=>{
        if(!event.target.matches('[data-side-choice]'))return;
        event.stopPropagation();
        this.choice=event.target.value; this.renderSelection();
      },{signal});
      this.querySelector('[data-side-remove]').addEventListener('click',()=>{
        const previous=this.querySelector('[data-side-choice]:checked');
        this.choice='none';this.renderSelection();
        if(previous&&!previous.disabled)previous.focus({preventScroll:true});
      },{signal});
      window.WillowSidesplash={
        canSubmit:form=>this.canSubmit(form),
        selectedFor:form=>this.appliesTo(form)&&!this.hidden&&this.choice!=='none',
        attach:(payload,form)=>this.attach(payload,form),
        summary:()=>!this.hidden&&this.choice!=='none'?{price:this.choice==='double'?90:45,label:this.copy[this.choice+'_selected']}:null
      };
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){this.choice='none';this.renderSelection();}},{signal});
      this.bootstrap();
    }
    disconnectedCallback(){
      // Moving the component next to the native picker is intentional.
      queueMicrotask(()=>{if(!this.isConnected){this.controller?.abort();this.availabilityNote?.remove();this.started=false;document.body.classList.remove('wv-side-preview-selected');}});
    }
    bootstrap(){
      this.update();
    }
    update(){
      const p=document.querySelector('body.willow-pdp product-info[data-update-url="true"] variant-picker');
      if(!p)return;
      // Keep accessory radios OUTSIDE native variant-picker: it collects every
      // checked fieldset input into Shopify option_values, including unrelated radios.
      if(p.nextElementSibling!==this)p.insertAdjacentElement('afterend',this);
      if(this.nextElementSibling!==this.availabilityNote)this.insertAdjacentElement('afterend',this.availabilityNote);
      const fs=Array.from(p.querySelectorAll('.variant-input-wrapper')).find(el=>/countertop/i.test(el.querySelector('legend')?.textContent||''));
      const selected=fs?.querySelector('input[type="radio"]:checked');
      const top=String(selected?.value||'');
      const changed=this.top && this.top!==top;
      this.isCabinet=!top||/cabinet/i.test(top);
      if(changed||this.isCabinet)this.choice='none';
      this.top=top;
      this.qty=Number(p.closest('product-info')?.querySelector('input[name="quantity"]')?.value||1);
      const topData=(()=>{try{return JSON.parse(document.querySelector('[data-wv-cts]')?.textContent||'[]').find(row=>normalize(row.name)===normalize(top))||{};}catch(_){return {};}})();
      const group=topData.group||'';
      this.isRounded=roundedProfile(this.data.productTitle,top,group,this.data.productSku,this.data.productHandle);
      this.height=profile(this.data.productTitle,top,group,this.data.productSku,this.data.productHandle);
      this.match=purchaseMatch(this.data.rows,top,this.height);
      this.matches=this.match?[this.match]:[];
      this.cap={single:!!selectionItem(this.match,'single',this.qty,'',''),double:!!selectionItem(this.match,'double',this.qty,'','')};
      this.hidden=this.isCabinet||!this.cap.single;
      this.availabilityNote.hidden=this.isCabinet;
      this.stockMessage.textContent=this.isRounded?this.copy.rounded_unavailable:this.cap.single?this.copy.stock_note:this.copy.stock_unavailable;
      const doubleChoice=this.querySelector('[value="double"]').closest('.wv-side-option');
      doubleChoice.hidden=!this.cap.double;
      this.querySelector('.wv-side-options').classList.toggle('wv-side-single-only',!this.cap.double);
      this.querySelector('.wv-side-help').hidden=!this.cap.double;
      if(this.hidden||(this.choice==='single'&&!this.cap.single)||(this.choice==='double'&&!this.cap.double))this.choice='none';
      this.querySelector('[data-side-material]').textContent=top.replace(/^DC /,'');
      const swatch=this.querySelector('[data-side-swatch]');
      const swatchSrc=topData.swatch||'';
      if(swatchSrc)swatch.src=swatchSrc;else swatch.removeAttribute('src');
      swatch.hidden=!swatchSrc;
      this.classList.toggle('wv-side-tall',this.height===5);
      this.querySelector('[data-side-dimensions]').textContent=this.height===5?this.copy.dimensions_manhattan:this.height===4?this.copy.dimensions_standard:this.copy.dimension_pending;
      this.querySelector('[data-side-image]').src=this.height===5?this.data.manhattanImage:this.data.standardImage;
      this.querySelector('[data-side-image]').hidden=this.height===null;
      const status=this.querySelector('[data-side-stock]');
      status.textContent=!this.matches.length?this.copy.unknown:!this.cap.single?this.copy.unavailable:!this.cap.double?this.copy.only_one:'';
      status.hidden=!status.textContent;
      this.querySelector('[value="single"]').disabled=!this.cap.single;
      // The owner confirmed Double = 2 × the Single price.
      this.querySelector('[value="double"]').disabled=!this.cap.double;
      this.querySelector('[data-side-reset]').textContent=changed?this.copy.reset:'';
      this.renderSelection();
    }
    renderSelection(){
      this.querySelectorAll('[data-side-choice]').forEach(input=>{input.checked=input.value===this.choice;});
      const total=pieces(this.choice,this.qty);
      this.querySelector('[data-side-result]').hidden=this.choice==='none';
      this.querySelector('[data-side-selection]').textContent=this.choice==='none'?'':this.copy[this.choice+'_selected'];
      const price=this.querySelector('[data-side-total]');
      price.textContent=total?this.copy.preview_single+' '+new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(45*total):'';
      this.querySelector('[data-side-pieces]').textContent=total?this.copy.qty+' '+String(total):'';
      this.querySelector('[data-side-error]').hidden=true;
      document.body.classList.toggle('wv-side-preview-selected',!this.hidden&&this.choice!=='none');
      const signature=[this.hidden,this.choice,this.qty,this.top].join('|');
      if(signature!==this.summarySignature){
        this.summarySignature=signature;
        document.dispatchEvent(new CustomEvent('willow:sidesplash-change'));
      }
    }
    appliesTo(form){
      return !!form?.querySelector('[name="id"]')&&form.closest('product-info')?.getAttribute('data-update-url')==='true';
    }
    showError(){
      const error=this.querySelector('[data-side-error]');error.hidden=false;error.textContent=this.copy.block;
      this.scrollIntoView({block:'center',behavior:'smooth'});
      error.focus({preventScroll:true});return false;
    }
    canSubmit(form){
      if(!this.appliesTo(form))return true;
      const choice=this.choice;
      this.update();
      if(choice!=='none'&&this.choice==='none')return this.showError();
      return true;
    }
    attach(payload,form){
      if(!this.appliesTo(form)||this.hidden||this.choice==='none')return false;
      const vanityId=String(form.querySelector('[name="id"]').value);
      const parent=payload.items.find(item=>String(item.id)===vanityId);
      if(!parent)throw new Error(this.copy.block);
      const item=selectionItem(this.match,this.choice,Number(parent.quantity||1),vanityId,this.data.productTitle);
      if(!item)throw new Error(this.copy.block);
      // Native Double bundles expand to their own components. Keep the accessory
      // as an ordinary cart line so Shopify can manage that bundle relationship.
      payload.items.push(item);
      return true;
    }
  }
  customElements.define('willow-sidesplash-preview',SidesplashPreview);
})();
  } catch(e) { console.error(e); }
})();

})();
